import { tv, type VariantProps } from 'tailwind-variants';
export type MlModalVariants = VariantProps<typeof mlModal>;

const mlModal = tv({
  slots: {
    dialog:
      'bottom-0 backdrop-blur-lg backdrop:bg-modal-overlay backdrop:bg-opacity-70 top-0 z-30 mx-10.75 mx-auto w-[calc(100%_-_2.5rem)] max-w-1042 rounded-30 px-4 pb-8 pt-6 md:w-[calc(100%_-_5.375rem)] lg:mx-auto lg:px-5.5 lg:py-6 landscape:h-[calc(100dvh_-_1.25rem)]',
    childrenContainer: 'lg:mt-6.5 mt-6',
  },
  variants: {
    variant: {
      login: {
        dialog: 'max-h-[46rem]',
      },
      location: {
        dialog: 'h-auto max-h-fit',
      },
      default: {
        dialog: 'md:h-none h-fit lg:max-h-614',
        childrenContainer: 'lg:mr-5.5 mr-2.5',
      },
      leadGen: {
        dialog:
          'w-full max-h-[90vh] overflow-y-auto landscape:h-[calc(100dvh_-_1.25rem)] landscape:max-h-none scrollbar-hidden',
      },
      slideshow: {
        dialog:
          '!pb-0 md:pb-8 !mt-0 !h-screen !w-screen !max-w-[100vw] overflow-x-hidden !max-h-screen !rounded-none',
        childrenContainer:
          'h-full w-full xl:min-h-[calc(100dvh_-_12.5rem)] flex flex-col justify-center',
      },
    },
  },
  compoundVariants: [],
});

export default mlModal;
